import { Field } from 'redux-form';
import { useTranslation } from 'react-i18next';
import { registerLocale } from "react-datepicker";
// TODO: move to higher level
import kk from 'date-fns/locale/kk';
import ru from 'date-fns/locale/ru';

import "react-datepicker/dist/react-datepicker.css";

import DateInput from './DateInput';
// import DateRangeInput from '../date-range-field/DateRange';

registerLocale('kk', kk);
registerLocale('ru', ru);

const LANGUAGE_MAP = {
  kz: 'kk'
};

const DateField = (props) => {
  // const component = props.period ? DateRangeInput : DateInput;
  const { i18n } = useTranslation();

  return (
    <div>
      <Field
        locale={LANGUAGE_MAP[i18n.language] || i18n.language}
        dateFormat="dd/MM/yyyy"
        label={props.label}
        name={props.name}
        id={props.id}
        typeName={props.typeName}
        order={props.order}
        required={props.required}
        values={props.options}
        component={DateInput}
      />
    </div>);
}

export default DateField;